"use client";

import { c as _c } from "react/compiler-runtime";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
type ShareProps = {
  title: string;
  text?: string;
  url?: string;
};
function Share(t0) {
  const $ = _c(7);
  const {
    title,
    text,
    url
  } = t0;
  let t1;
  if ($[0] !== text || $[1] !== title || $[2] !== url) {
    t1 = () => {
      const shareUrl = url ?? window.location.href;
      if (navigator.canShare({
        title,
        text,
        url: shareUrl
      })) {
        navigator.share({
          title,
          text,
          url: shareUrl
        });
      } else {
        navigator.clipboard.writeText(url ?? window.location.href);
        toast("URL copied to clipboard", {
          duration: 2000
        });
      }
    };
    $[0] = text;
    $[1] = title;
    $[2] = url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Share2 />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <Button size="icon" variant="ghost" onClick={t1}>{t2}</Button>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default Share;